export const getShortenedAddress = (address: string): string => {
  if (!address) {
    return address
  }
  return `${address.substring(0, 4)}...${address.substring(address.length - 4)}`
}
